module.exports = __webpack_public_path__ + "img/huge.be5030ca.webp";